import {match} from 'ts-pattern';

import {InspectionState} from '@dms/api/core';
import i18n from '@dms/i18n';

export const getStatusTranslation = (status: string) =>
  match<string, string>(status)
    .with(InspectionState.IN_PROGRESS, () => i18n.t('general.labels.inProgress'))
    .with(InspectionState.FINISHED_AUDIT, () => i18n.t('general.labels.complete'))
    .with(InspectionState.TO_FINISHING, () => i18n.t('general.labels.toFinishing'))
    .with(InspectionState.TO_REVISION, () => i18n.t('general.labels.toRevision'))
    .with(InspectionState.IN_REVISION, () => i18n.t('general.labels.inRevision'))
    .otherwise(() => i18n.t('general.labels.toCheck'));
